<script setup>
import { ref, watch, toRefs } from "vue";
import { DeviceInfo } from "../utils/deviceInfo.js";
import Modal from "@/components/Modal.vue";

const props = defineProps({
  visible: Boolean,
  toggle: Function,
  deviceInfo: DeviceInfo,
  camerasCount: { type: Number, default: 0 }
});
const emit = defineEmits(["change-camera"]);
const { visible } = toRefs(props);
const iphoneModel = ref(window.localStorage.getItem("iphoneModel"));
const isIos = props.deviceInfo?.isIos();

watch(visible, (val) => {
  if (val) {
    iphoneModel.value = window.localStorage.getItem("iphoneModel");
  }
});

const handlePhotoManually = () => window.location.href = `${window.location.origin}/${import.meta.env.VITE_PHOTO_AUTH_PREFIX}${window.location.search}`;
</script>

<template>
<Modal v-if="visible" @close="toggle()">
  <template #title>
    {{ $t("retry.sorry") }}
  </template>
  <template #description>
    <p>{{ $t("retry.unable_to_capture") }}</p>
    <p class="mt-5" v-if="isIos && iphoneModel">{{ $t("retry.select_correct_phone_model", { phoneModel: iphoneModel }) }}</p>
  </template>
  <template #footer>
    <div class="flex flex-col justify-center gap-4">
      <button class="bg-transparent border-none text-[17px] leading-none cursor-pointer text-center text-(--secondary) font-normal py-1" @click="toggle()">
        {{ $t("try_again") }}
      </button>
      <button v-if="isIos || camerasCount > 1" class="bg-transparent border-none text-[17px] leading-none cursor-pointer text-center text-(--secondary) font-normal py-1" @click="emit('change-camera')">
        {{ isIos ? $t("select_phone_model") : $t("retry.try_another_camera") }}
      </button>
      <button class="bg-transparent border-none text-[17px] leading-none cursor-pointer text-center text-(--secondary) font-normal py-1" @click="handlePhotoManually">
        {{ $t("retry.take_photo_manually") }}
      </button>
    </div>
  </template>
</Modal>
</template>